import { Directive, ElementRef } from '@angular/core';

@Directive({ selector: '[hf-sidepane]' })
export class SidepaneDirective {
  constructor(private elRef: ElementRef) {}
}
